import { AsyncPipe, NgIf, NgStyle } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { FlexModule } from '@angular/flex-layout/flex';
import { CanDisable, mixinDisabled } from '@angular/material/core';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import {
  Countertop,
  CountertopMaterial,
  CuttingMaterial,
  LegacyDialogsService,
  MatBaseGroupPostforming,
  PostformingSideEnum,
} from 'cloud-shared-lib';
import { Observable, filter, tap } from 'rxjs';

import { BazisMaterialHelper } from '../../../helpers/bazis-material.helper';
import {
  CuttingMaterialBaseDialogComponent,
  CuttingMaterialBaseDialogData,
} from '../../cutting-material-base-dialog/cutting-material-base-dialog.component';
import { CountertopSettingsStateService } from '../countertop-settings-state.service';
import { CountertopsAvailableComponentsService } from '../countertops-available-components.service';
import { ItemCardComponent } from '../item-card/item-card.component';

export class MaterialsBase {}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const _MaterialsMixinBase = mixinDisabled(MaterialsBase);

@Component({
  selector: 'csl-materials',
  templateUrl: './materials.component.html',
  styleUrls: ['./materials.component.scss'],
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled'],
  standalone: true,
  imports: [NgIf, FlexModule, ItemCardComponent, NgStyle, ExtendedModule, AsyncPipe, MatLegacyDialogModule],
})
export class MaterialsComponent extends _MaterialsMixinBase implements CanDisable, OnChanges {
  @Input() showMaterialsPrice: boolean;
  @Input() currencySymbol = '';
  @Input() showQuantityInStock: boolean;
  @Input() postformingGroups?: MatBaseGroupPostforming[];

  action$: Observable<any>;
  countertop$: Observable<Countertop>;
  material$: Observable<CountertopMaterial>;

  defaultEdgeDescription = $localize`Выберите материал облицовки кромки`;
  defaultMaterialDescription = $localize`Выберите материал столешницы`;
  countertop: Countertop;
  material: CountertopMaterial;
  materialGroupsWithPostforming: Map<number, PostformingSideEnum> = new Map();

  constructor(
    private dialogs: LegacyDialogsService,
    private countertopSettingsService: CountertopSettingsStateService,

    private facadesAvailableComponentsService: CountertopsAvailableComponentsService
  ) {
    super();

    this.countertop$ = this.countertopSettingsService.countertop$.pipe(tap(c => (this.countertop = c)));
    this.material$ = this.countertopSettingsService.material$.pipe(tap(m => (this.material = m)));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.postformingGroups?.currentValue) {
      this.materialGroupsWithPostforming = new Map(
        changes.postformingGroups.currentValue
          .filter(m => m.postformingSide !== PostformingSideEnum.None)
          .map(m => [m.inMatBaseId, m.postformingSide])
      );
    }
  }

  async selectMaterial(): Promise<void> {
    this.action$ = this.dialogs
      .component<CuttingMaterialBaseDialogData, CuttingMaterial[]>(
        CuttingMaterialBaseDialogComponent,
        {
          showPrices: this.showMaterialsPrice,
          currencyName: this.currencySymbol,
          materialsToExclude: [],
          multiple: false,
          dataProvider: this.facadesAvailableComponentsService,
          showQuantityInStock: this.showQuantityInStock,
        },
        1150
      )
      .pipe(
        filter(r => !!r?.length),
        tap(m => {
          const material: CuttingMaterial = m[0];
          const countertopMaterial: CountertopMaterial = {
            ...material,
            postforming:
              this.materialGroupsWithPostforming.get(material.inMaterialBaseGroupId) || PostformingSideEnum.None,
          };
          this.countertopSettingsService.setMaterial(countertopMaterial);
        })
      );
  }

  getMaterialName(material: CuttingMaterial): string {
    return material ? BazisMaterialHelper.formatMaterialNameAndArticle(material.name, material.article, '') : '';
  }
}
